export default {install (Vue)
    {
    const estilos = {
        oscuro(){
            return "blue-grey darken-4";
        },
        rojo(){
            return "red";
        },
        accent() {
            return "#a9c6c9";
        },
        toolbar() {
            return "v-sheet--offset mx-auto pa-2";
        },
        contenedor(){
            return "white pa-3 ma-0";
        },
        seccion(){
            return "mt-5 mx-auto ma-7";
        },
        observadoToolbar(){
            return "#E65100";
        },
        observadoContent(){
            return "#FFE0B2";
        },
        estadoTramite(){
            return "margin:1px; padding:2px; color:#7CB342; font-size: 9px;border: 1px solid #7CB342;";
        },
        estado(){
            return "margin:0.5px; padding:1px; color:#00897B; font-size: 9px;border: 1px solid #00897B;";
        },
        mensajeLargo(){
            return "font-size: 9px;  color: #00897B;";
        },
        cuadradoNotificacion(){
            return " height: 9px; padding:2px; background: #00897B;";
        },
        cuadradoEstadoTramite(){
            return "height: 9px;  padding:2px; background: #7CB342;";
        },

  }
  Vue.prototype.$estilos = estilos;
}}
